import { Link } from "react-router-dom";
import { useTheme } from "../../lib/ThemeContext";
// Ajout de l'icône Gift ou Snowflake pour les saisons
import { Sun, Moon, Snowflake } from "lucide-react"; 
import Navigation from "./Navigation";
import "../../styles/Header.css";

export default function Header() {
  // On récupère toutes nos nouvelles données du contexte
  const { 
    baseMode, 
    toggleBaseMode, 
    seasonalEnabled, 
    toggleSeasonal,
    currentSeason 
  } = useTheme(); 

  const isDarkMode = baseMode === 'dark';

  return (
    <header className="header">
      <div className="header__container">
        
        {/* LOGO */}
      

        {/* NAVIGATION */}
        <div className="header__nav">
          <Navigation />
        </div>



      </div>
    </header>
  );
}